import PropTypes from 'prop-types';
import React from 'react';
import { useTheme, alpha } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import {
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid,
  Container,
  Divider,
  Stack,
  Typography,
  Button,
  TextField,
  Box,
  FormControl,
  FormLabel,
  Tooltip,
  RadioGroup,
  FormControlLabel,
  Radio,
  Chip,
  Autocomplete,
  FormGroup,
  Checkbox,
  useMediaQuery
} from '@mui/material';
import {
  Timeline,
  TimelineItem,
  TimelineContent,
  TimelineConnector,
  TimelineSeparator,
  TimelineDot,
  LoadingButton
} from '@mui/lab';
import { toast } from 'react-hot-toast';
import _ from 'lodash';
import arrowBackFilled from '@iconify/icons-eva/arrow-back-fill';
import plusCircleFill from '@iconify/icons-eva/plus-circle-fill';
import questionMarkCircleFill from '@iconify/icons-eva/question-mark-circle-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import arrowCircleUpOutline from '@iconify/icons-eva/arrow-circle-up-outline';
import arrowCircleDownOutline from '@iconify/icons-eva/arrow-circle-down-outline';
import edit2Outline from '@iconify/icons-eva/edit-2-outline';
import personOutline from '@iconify/icons-eva/person-outline';
import menu2Outline from '@iconify/icons-eva/menu-2-outline';
import eyeFill from '@iconify/icons-eva/eye-fill';
import shareFill from '@iconify/icons-eva/share-fill';
import { Icon } from '@iconify/react';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment-timezone';
//
import Page from '../components/Page';
import * as appServices from '../services/aplikasi';
import * as userService from '../services/user';
import * as instansiService from '../services/instansi';
import * as myLayananService from '../services/mylayanan';
import findIndex from '../utils/indexFinder';
import useWidth from '../hooks/useWidth';
import { getBaseURL } from '../utils/envGetter';
import RekomendasiCTA from '../components/RekomendasiCTA';

const AplikasiCreator = ({ user }) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const { id } = useParams();
  const role = user?.attributes?.role;

  const baseStyle = {
    padding: 1,
    cursor: 'pointer'
  };

  const styles = {
    selectedJenis: {
      color: theme.palette.primary.main,
      ...baseStyle
    },
    notSelectedJenis: {
      color: '#424242',
      ...baseStyle
    }
  };

  const [toggleRefresh, setToggleRefresh] = React.useState(false);
  const [app, setApp] = React.useState({});
  const [selectedJenis, setSelectedJenis] = React.useState('formbuilder'); // 'formbuilder / release'
  const [submitting, setIsSubmitting] = React.useState(false);
  const [instansis, setInstansis] = React.useState([]);

  const [title, setTitle] = React.useState('');
  const [description, setDescription] = React.useState('');
  const [instansi, setInstansi] = React.useState('');
  const [cpu, setCpu] = React.useState('');
  const [ram, setRam] = React.useState('');
  const [storage, setStorage] = React.useState('');
  const [os, setOs] = React.useState('');

  const [rekomendasi, setRekomendasi] = React.useState('');
  const [rekomendasis, setRekomendasis] = React.useState([]);

  const [pic, setPic] = React.useState('');

  const getRekomendasis = async () => {
    if (_.isEmpty(user)) return;
    try {
      const idInstansi = user?.attributes?.id_instansi;

      const body = {
        id_instansi: idInstansi,
        role: user?.attributes?.role
      };
      const result = await myLayananService.getRekomendasis(body);

      const data = [];

      result.data.forEach((item) => {
        data.push({
          label: `${item?.attributes?.name} - ${item?.attributes?.createdAt} - ${item?.attributes?.status}`,
          id: item?.id,
          meta: item
        });
      });

      if (app?.meta?.id_rekomendasi) {
        const rekomendasiValue = data.filter((item) => item.id === app?.meta?.id_rekomendasi);
        setRekomendasi(rekomendasiValue[0]);
      }

      setPic(app?.meta?.pics);
      setRekomendasis(data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  const getInstansis = async () => {
    try {
      const result = await instansiService.getAll();
      const { data } = result;

      const newInstansis = [];
      data.forEach((item) => {
        newInstansis.push({ id: item?.id_instansi, label: item?.name });
      });

      const filteredData = ['admin', 'superadmin'].includes(role)
        ? newInstansis
        : newInstansis.filter((item) => item.id === user?.attributes?.id_instansi);
      setInstansis(filteredData);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getInstansis();
  }, [role]);

  const getApp = async () => {
    try {
      if (!id) return toast.error('Maaf, gagal mendapatkan ID App');
      const body = {
        id,
        role: user?.attributes?.role
      };
      const result = await appServices.getByID(body);
      setApp(result.data);
      setTitle(result.data.attributes.title);
      if (result.data.attributes.id_instansi) {
        setInstansi({
          id: result?.data?.relationships?.instansi?.id_instansi,
          label: result?.data?.relationships?.instansi?.name
        });
      }

      setDescription(result.data.attributes.description);
      setCpu(result.data.attributes.cpu);
      setRam(result.data.attributes.ram);
      setStorage(result.data.attributes.storage);
      setOs(result.data.attributes.os);
      console.log('data', result.data);
    } catch (error) {
      toast.error(error.message);
    }
  };

  React.useEffect(() => {
    getApp();
  }, [toggleRefresh, selectedJenis]);

  React.useEffect(() => {
    getRekomendasis();
  }, [app]);

  const updateApp = async (complements, versions) => {
    try {
      let body = {};
      if (_.isEmpty(complements) && _.isEmpty(versions)) {
        if (title === 'Nama Aplikasi')
          return toast.error('Harap ubah nama aplikasi terlebih dahulu');
        if (!rekomendasi?.id) return toast.error('Harap pilih nomor rekomendasi terlebih dahulu');

        const currentRekomendasi = rekomendasis[findIndex(rekomendasis, rekomendasi?.id, 'id')];

        if (currentRekomendasi?.meta?.attributes?.status !== 'approved')
          return toast.error(
            `Maaf, permohonan rekomendasi ${currentRekomendasi?.meta?.attributes?.name} belum disetujui`
          );

        if (!pic) return toast.error('PIC harus di isi');

        body = {
          data: {
            id: app.id,
            attributes: {
              title,
              description,
              id_instansi: instansi.id,
              cpu,
              ram,
              storage,
              os
            },
            meta: { ...app.meta, id_rekomendasi: rekomendasi.id, pics: pic }
          }
        };
      } else {
        body = {
          data: {
            id: app.id,
            meta: { ...app.meta, complements, versions }
          }
        };
      }

      setIsSubmitting(true);
      toast
        .promise(appServices.updateForm(body), {
          loading: 'Menyimpan data ...',
          error: <b>Maaf, terjadi kesalahan</b>,
          success: <b>Data berhasil disimpan</b>
        })
        .then(() => {
          setToggleRefresh(!toggleRefresh);
        });
    } catch (error) {
      toast.error(error.message);
    }
    setIsSubmitting(false);
  };

  return (
    <Page title="Informasi Aplikasi | Peladen Pemda DIY">
      <Container>
        <Stack direction="column" spacing={2}>
          <Stack direction="row" alignItems="center" spacing={2} mb={6}>
            <Icon
              cursor="pointer"
              onClick={() => navigate(-1, { replace: true })}
              icon={arrowBackFilled}
              width={32}
              height={32}
              style={{ color: theme.palette.primary.main }}
            />
            <Typography variant="h4">Detail Aplikasi</Typography>
          </Stack>
          {_.isEmpty(app.id) && <Typography variant="body2">ID App tidak ditemukan</Typography>}
          {!_.isEmpty(app.id) && (
            <Stack direction="column" spacing={2}>
              <Typography gutterBottom variant="h6" component="div">
                Informasi Aplikasi
              </Typography>
              <Divider variant="fullWidth" />
              <TextField value={title} label="Judul" onChange={(e) => setTitle(e.target.value)} />
              <TextField
                value={description}
                label="Deskripsi"
                onChange={(e) => setDescription(e.target.value)}
                multiline
              />
              <Autocomplete
                fullWidth
                disablePortal
                id="combo-box-instansi"
                options={instansis}
                value={instansi}
                onChange={(event, newValue) => {
                  setInstansi(newValue);
                }}
                renderInput={(params) => (
                  <TextField size="small" {...params} label="Pilih Instansi" />
                )}
              />
              <Autocomplete
                isRequired="true"
                fullWidth
                disablePortal
                id="combo-box-rekomendasi"
                options={rekomendasis}
                value={rekomendasi}
                onChange={(event, newValue) => {
                  setRekomendasi(newValue);
                }}
                renderInput={(params) => (
                  <TextField size="small" {...params} label="Nomor Rekomendasi" />
                )}
              />
              <TextField value={pic} label="PIC" onChange={(e) => setPic(e.target.value)} />
              <Typography gutterBottom variant="h6" component="div">
                Spesifikasi Server
              </Typography>
              <Divider variant="fullWidth" />
              <TextField
                value={cpu}
                label="CPU - Isikan jumlah Core yang digunakan"
                onChange={(e) => setCpu(e.target.value)}
                type="number"
              />
              <TextField
                value={ram}
                label="RAM - Isikan kapasitas RAM"
                onChange={(e) => setRam(e.target.value)}
                type="number"
              />
              <TextField
                value={storage}
                label="Storage - Isikan kapasitas storage yang digunakan, satuan MB"
                onChange={(e) => setStorage(e.target.value)}
                type="number"
              />
              <TextField
                value={os}
                label="OS - Isikan Os yang digunakan"
                onChange={(e) => setOs(e.target.value)}
              />
              <RekomendasiCTA />
              <Box>
                <LoadingButton
                  onClick={() => updateApp({}, {})}
                  variant="contained"
                  loading={submitting}
                >
                  Simpan
                </LoadingButton>
              </Box>
              {app?.meta?.id_rekomendasi && (
                <>
                  <Divider />

                  <Stack
                    direction="row"
                    spacing={2}
                    justifyContent="center"
                    divider={<Divider orientation="vertical" flexItem />}
                  >
                    <Typography
                      onClick={() => setSelectedJenis('formbuilder')}
                      variant="h6"
                      sx={
                        selectedJenis === 'formbuilder'
                          ? styles.selectedJenis
                          : styles.notSelectedJenis
                      }
                    >
                      Versi Aplikasi
                    </Typography>
                    <Typography
                      onClick={() => setSelectedJenis('release')}
                      variant="h6"
                      sx={
                        selectedJenis === 'release' ? styles.selectedJenis : styles.notSelectedJenis
                      }
                    >
                      Timeline ({app?.meta?.versions?.length || '0'})
                    </Typography>
                  </Stack>

                  <Divider />
                  {selectedJenis === 'formbuilder' && (
                    <FormBuilder
                      user={user}
                      app={app}
                      toggleRefresh={toggleRefresh}
                      setToggleRefresh={setToggleRefresh}
                      updateApp={updateApp}
                      rekomendasi={rekomendasis}
                    />
                  )}
                  {selectedJenis === 'release' && <Release app={app} />}
                </>
              )}
            </Stack>
          )}
        </Stack>
      </Container>
    </Page>
  );
};

const Release = ({ app }) => {
  const data = '';
  const theme = useTheme();
  return (
    <Stack direction="column" spacing={1}>
      {!_.isEmpty(app?.meta?.versions) &&
        app.meta.versions.map((item, index) => (
          <Stack direction="row" spacing={1}>
            <TimelineItem>
              <TimelineSeparator>
                <TimelineDot color="warning" />
                <TimelineConnector />
              </TimelineSeparator>
              <TimelineContent sx={{ py: '12px', px: 2, minWidth: 800 }}>
                <Typography variant="h6" component="span">
                  {item?.attributes?.label}
                </Typography>
                <Typography>{item?.attributes?.changelog}</Typography>
              </TimelineContent>
            </TimelineItem>
          </Stack>
        ))}
    </Stack>
  );
};

const FormBuilder = ({ user, app, toggleRefresh, setToggleRefresh, updateApp, rekomendasi }) => {
  const { id } = useParams();
  const data = '';
  const theme = useTheme();
  const navigate = useNavigate();
  const width = useWidth(useTheme, useMediaQuery);

  const [mode, setMode] = React.useState('asking'); // asking or filling
  const [editIndex, setEditIndex] = React.useState(); // to mark edit version index
  const [complement, setComplement] = React.useState('jenis'); // menu or roles
  const [complementName, setComplementName] = React.useState('');
  const [complements, setComplements] = React.useState({ jenis: [], libs: [] });
  const [versions, setVersions] = React.useState([]);
  const [form, setForm] = React.useState('');
  const [complementJenis, setComplementJenis] = React.useState();
  const [complementRole, setComplementRole] = React.useState();
  const [complementsCombo, setComplementsCombo] = React.useState({ jenis: [], libs: [] });

  const updateComplements = async () => {
    setComplements(app?.meta?.complements || { jenis: [], libs: [] });
  };

  const updateVersions = async () => {
    setVersions(app?.meta?.versions || []);
  };

  React.useEffect(() => {
    updateComplements();
    updateVersions();
  }, [app]);

  const addComplement = async () => {
    if (!complementName || !complement) return toast.error('Jenis/Framework belum diisi');

    const id = uuidv4();

    const data = !_.isEmpty(complements[complement]) ? complements[complement] : [];

    // const data = {
    //   ...complements,
    //   [complement]: {
    //     ...complements[complement],
    //     id,
    //     type: complement,
    //     attributes: { name: complementName }
    //   }
    // };

    data.push({ id, type: complement, attributes: { name: complementName } });

    setComplements({ ...complements, [complement]: data });
    setComplementName('');
  };

  const deleteComplement = async (item) => {
    const index = findIndex(complements[item.type], item.id, 'id');

    if (index > -1) {
      const data = complements[item.type].filter((item, itemIndex) => itemIndex !== index);
      setComplements({ ...complements, [item.type]: data });
    }
  };

  const updateComboList = () => {
    const dataJenis = [];
    complements?.jenis.forEach((item) => {
      dataJenis.push({ id: item.id, label: item.attributes.name });
    });

    const dataLibs = [];
    complements?.libs.forEach((item) => {
      dataLibs.push({ id: item.id, label: item.attributes.name });
    });

    setComplementsCombo({ ...complementsCombo, jenis: dataJenis, libs: dataLibs });
  };

  React.useEffect(() => {
    updateComboList();
  }, [updateApp]);

  const addVersion = () => {
    try {
      if (!form.label) return toast.error('Versi belum diisi');
      if (!form.changelog) return toast.error('Change log belum diisi');
      if (!form.database) return toast.error('Database belum diisi');
      if (!form.rekom) return toast.error('Rekomendasi belum diisi');
      if (!form.jenis) return toast.error('Jenis belum dipilih');
      if (_.isEmpty(form.libs)) return toast.error('Framework belum dipilih');

      const currentRekomendasi = rekomendasi[findIndex(rekomendasi, form.rekom?.id, 'id')];

      if (currentRekomendasi?.meta?.attributes?.status !== 'approved')
        return toast.error(
          `Maaf, permohonan rekomendasi ${currentRekomendasi?.meta?.attributes?.name} belum disetujui`
        );

      // validating libs
      let counts = 0;
      form.libs.forEach((item) => {
        if (item.checked) counts += 1;
      });

      if (counts < 1) return toast.error('Framework belum dipilih');

      if (mode === 'fillingupdate') {
        const data = [...versions];
        data[editIndex].attributes.label = form.label;
        data[editIndex].attributes.changelog = form.changelog;
        data[editIndex].attributes.database = form.database;
        data[editIndex].attributes.rekom = form.rekom;
        data[editIndex].attributes.jenis = form.jenis;
        data[editIndex].attributes.libs = form.libs;

        setVersions(data);
        setMode('asking');
        setForm({});
        updateApp(complements, data);
      } else {
        const index = versions.length;
        const id = uuidv4();
        const data = [...versions];
        data.push({
          id,
          type: 'app',
          attributes: {
            label: form.label,
            changelog: form.changelog,
            database: form.database,
            rekom: form.rekom,
            jenis: form.jenis,
            libs: form.libs,
            index
          }
        });

        setVersions(data);
        setMode('asking');
        setForm({});
        updateApp(complements, data);
      }
    } catch (error) {
      toast.error(error.message);
    }
  };

  const handleChangeCheckbox = (index, value) => {
    const libs = form.libs || [];

    if (!_.isEmpty(libs) && libs.length >= index + 1) {
      libs[index].checked = value;
      libs[index].id = complementsCombo.libs[index].id;
      libs[index].label = complementsCombo.libs[index].label;
    } else {
      libs.push({
        checked: value,
        id: complementsCombo.libs[index].id,
        label: complementsCombo.libs[index].label
      });
    }
    setForm({ ...form, libs });
  };

  const deleteVersion = (item, index) => {
    // const versionIndex = findIndex(versions, item.id, 'id');
    const newVersions = versions.filter((qItem, qIndex) => qItem.id !== item.id);
    updateApp(complements, newVersions);
    // alert(newVersions);
  };

  const toggleEditVersion = (item, index) => {
    setMode('fillingupdate');
    setEditIndex(index);
    setForm({
      libs: item?.attributes?.libs,
      jenis: item?.attributes?.jenis,
      changelog: item?.attributes?.changelog,
      database: item?.attributes?.database,
      rekom: item?.attributes?.rekom,
      label: item?.attributes?.label
    });
  };

  const changeVersionPosition = (item, index, target) => {
    // target = up/down
    try {
      if (target === 'up' && index === 0) return;
      if (target === 'down' && index === versions.length - 1) return;
      const data = [...versions];
      const newVersions = [...versions];

      const targetValue = target === 'down' ? 1 : -1;

      newVersions[index] = data[index + targetValue];
      newVersions[index + targetValue] = data[index];

      setVersions(newVersions);
      updateApp(complements, newVersions);
    } catch (error) {
      toast.error(error.message);
    }
  };

  return (
    <Stack direction="column">
      <Stack
        direction={['xs', 'sm'].includes(width) ? 'column' : 'row'}
        spacing={2}
        divider={<Divider orientation="vertical" flexItem />}
      >
        <Stack direction="column" spacing={2} sx={{ flex: 8 }}>
          <Stack direction="column" spacing={2}>
            {!_.isEmpty(versions) &&
              versions.map((item, index) => (
                <Stack direction="column" spacing={2}>
                  {mode === 'fillingupdate' && editIndex === index ? (
                    <Stack direction="column" spacing={2}>
                      <TextField
                        multiline="true"
                        fullWidth
                        label="Versi"
                        placeholder="Versi"
                        value={form.label}
                        onChange={(e) => setForm({ ...form, label: e.target.value })}
                      />
                      <TextField
                        multiline="true"
                        fullWidth
                        label="Change log"
                        placeholder="Change log"
                        value={form.changelog}
                        onChange={(e) => setForm({ ...form, changelog: e.target.value })}
                      />
                      <TextField
                        multiline="true"
                        fullWidth
                        label="Database"
                        placeholder="Database"
                        value={form.database}
                        onChange={(e) => setForm({ ...form, database: e.target.value })}
                      />
                      <Autocomplete
                        isRequired="true"
                        fullWidth
                        disablePortal
                        id="combo-box-rekomendasi"
                        options={rekomendasi}
                        value={form.rekom}
                        onChange={(event, newValue) => {
                          setForm({ ...form, rekom: newValue });
                        }}
                        renderInput={(params) => (
                          <TextField size="small" {...params} label="Rekomendasi" />
                        )}
                      />
                      {!_.isEmpty(complementsCombo?.jenis) ? (
                        <Autocomplete
                          disablePortal
                          id="combo-box-jenis"
                          options={complementsCombo.jenis}
                          value={form.jenis}
                          onChange={(event, newValue) => {
                            setForm({ ...form, jenis: newValue });
                          }}
                          sx={{ width: 300 }}
                          renderInput={(params) => (
                            <TextField size="small" {...params} label="Jenis" />
                          )}
                        />
                      ) : (
                        <Typography variant="body2">
                          Jenis tidak ditemukan, silakan tambah terlebih dahulu pada menu tambah
                          jenis/framework
                        </Typography>
                      )}

                      <Typography variant="body1">Framework</Typography>
                      <FormGroup>
                        {!_.isEmpty(complementsCombo?.libs) ? (
                          complementsCombo?.libs?.map((item, index) => (
                            <FormControlLabel
                              checked={(form.libs && form?.libs[index]?.checked) || false}
                              onChange={(e) => handleChangeCheckbox(index, e.target.checked)}
                              control={<Checkbox />}
                              label={item.label}
                            />
                          ))
                        ) : (
                          <Typography variant="body2">
                            Framework tidak ditemukan, silakan tambah terlebih dahulu pada menu
                            tambah jenis/framework{' '}
                          </Typography>
                        )}
                      </FormGroup>
                      <Stack direction="row" spacing={1}>
                        <Button variant="outlined" onClick={addVersion}>
                          {mode === 'fillingupdate' ? 'Update Versi' : 'Tambah Versi'}
                        </Button>
                        <Button
                          variant="outlined"
                          sx={{
                            borderColor: theme.palette.error.main,
                            color: theme.palette.error.main
                          }}
                          onClick={() => setMode('asking')}
                        >
                          Cancel
                        </Button>
                      </Stack>
                    </Stack>
                  ) : (
                    <>
                      <Stack direction="row" spacing={1}>
                        <Typography variant="body1">{index + 1}.</Typography>
                        <Typography variant="body1">{item?.attributes?.label}</Typography>
                      </Stack>
                      <Stack direction="row" spacing={1}>
                        <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
                          <Box sx={{ my: 3, mx: 2 }}>
                            <Grid container alignItems="center">
                              <Grid item xs>
                                <Typography gutterBottom variant="h4" component="div">
                                  Changelog
                                </Typography>
                              </Grid>
                              <Grid item>
                                <Typography gutterBottom variant="h6" component="div">
                                  {item?.attributes?.label}
                                </Typography>
                              </Grid>
                            </Grid>
                            <Typography color="text.secondary" variant="body2">
                              {item?.attributes?.changelog}
                            </Typography>
                          </Box>
                          <Divider variant="fullWidth" />
                          <List
                            sx={{
                              width: '100%',
                              bgcolor: 'background.paper'
                            }}
                          >
                            <ListItem>
                              <ListItemAvatar>
                                <Avatar>OS</Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary="Jenis"
                                secondary={item?.attributes?.jenis?.label}
                              />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                            <ListItem>
                              <ListItemAvatar>
                                <Avatar>DB</Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary="Database"
                                secondary={item?.attributes?.database}
                              />
                            </ListItem>
                            <Divider variant="inset" component="li" />
                            <ListItem>
                              <ListItemAvatar>
                                <Avatar>R</Avatar>
                              </ListItemAvatar>
                              <ListItemText
                                primary="Rekomendasi"
                                secondary={item?.attributes?.rekom?.id}
                              />
                              <Button
                                onClick={() =>
                                  window.open(
                                    `${getBaseURL()}/dashboard/services/${
                                      item?.attributes?.rekom?.id
                                    }?navigateBack=aplikasi`,
                                    '_blank'
                                  )
                                }
                                startIcon={<Icon icon={eyeFill} style={{ color: '#FFFFFF' }} />}
                                variant="contained"
                              >
                                Preview
                              </Button>
                            </ListItem>
                          </List>
                          <Divider variant="fullWidth" />
                          <Box sx={{ m: 2 }}>
                            <Typography gutterBottom variant="body1">
                              Framework
                            </Typography>
                            <Stack direction="row" spacing={1}>
                              {!_.isEmpty(item?.attributes?.libs) &&
                                item?.attributes?.libs.map(
                                  (itemLibs) =>
                                    itemLibs.label &&
                                    itemLibs.checked &&
                                    complementsCombo.libs
                                      .map((itemCM) => itemCM.label)
                                      .includes(itemLibs.label) && (
                                      <Chip color="primary" label={itemLibs.label} />
                                    )
                                )}
                            </Stack>
                          </Box>
                        </Box>
                      </Stack>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <hr
                          style={{
                            width: 100,
                            height: 1,
                            borderColor: theme.palette.grey[100],
                            opacity: 0.5,
                            flex: 1
                          }}
                        />
                        <Icon
                          cursor="pointer"
                          onClick={() => deleteVersion(item, index)}
                          icon={trash2Outline}
                          width={24}
                          height={24}
                          style={{ color: theme.palette.error.main }}
                        />
                        <Icon
                          cursor="pointer"
                          onClick={() => toggleEditVersion(item, index)}
                          icon={edit2Outline}
                          width={24}
                          height={24}
                          style={{ color: theme.palette.primary.main }}
                        />
                        <Icon
                          cursor="pointer"
                          onClick={() => changeVersionPosition(item, index, 'up')}
                          icon={arrowCircleUpOutline}
                          width={24}
                          height={24}
                          style={{
                            color: index > 0 ? theme.palette.info.main : theme.palette.grey[500]
                          }}
                        />
                        <Icon
                          cursor="pointer"
                          onClick={() => changeVersionPosition(item, index, 'down')}
                          icon={arrowCircleDownOutline}
                          width={24}
                          height={24}
                          style={{
                            color:
                              index !== versions.length - 1
                                ? theme.palette.info.main
                                : theme.palette.grey[500]
                          }}
                        />
                      </Stack>
                    </>
                  )}
                </Stack>
              ))}
          </Stack>

          {mode === 'asking' && (
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography>Tambah Versi</Typography>
              <Icon
                cursor="pointer"
                onClick={() => setMode('filling')}
                icon={plusCircleFill}
                width={32}
                height={32}
                style={{ color: theme.palette.primary.main }}
              />
            </Stack>
          )}

          {/* {mode === 'asking' && (
            <Stack direction="row" spacing={1} justifyContent="center">
              <Button
                onClick={() => window.open(`${getBaseURL()}/aplikasi/preview/${id}`, '_blank')}
                startIcon={<Icon icon={eyeFill} style={{ color: '#FFFFFF' }} />}
                variant="contained"
              >
                Preview
              </Button>
              <Button
                startIcon={<Icon icon={shareFill} style={{ color: '#FFFFFF' }} />}
                variant="contained"
                onClick={() => {
                  navigator.clipboard.writeText(`${getBaseURL()}/aplikasi/form/${id}`);
                  toast.success('Link telah di-copy');
                }}
              >
                Bagikan Link
              </Button>
            </Stack>
          )} */}

          {mode === 'filling' && (
            <Stack direction="column" spacing={2}>
              <TextField
                multiline="true"
                fullWidth
                label="Versi"
                placeholder="Versi"
                value={form.label}
                onChange={(e) => setForm({ ...form, label: e.target.value })}
              />
              <TextField
                multiline="true"
                fullWidth
                label="Change log"
                placeholder="Change log"
                value={form.changelog}
                onChange={(e) => setForm({ ...form, changelog: e.target.value })}
              />
              <TextField
                multiline="true"
                fullWidth
                label="Database"
                placeholder="Database"
                value={form.database}
                onChange={(e) => setForm({ ...form, database: e.target.value })}
              />
              <Autocomplete
                isRequired="true"
                fullWidth
                disablePortal
                id="combo-box-rekomendasi"
                options={rekomendasi}
                value={form.rekom}
                onChange={(event, newValue) => {
                  setForm({ ...form, rekom: newValue });
                }}
                renderInput={(params) => <TextField size="small" {...params} label="Rekomendasi" />}
              />
              {!_.isEmpty(complementsCombo?.jenis) ? (
                <Autocomplete
                  disablePortal
                  id="combo-box-jenis"
                  options={complementsCombo.jenis}
                  value={form.jenis}
                  onChange={(event, newValue) => {
                    setForm({ ...form, jenis: newValue });
                  }}
                  sx={{ width: 300 }}
                  renderInput={(params) => <TextField size="small" {...params} label="Jenis" />}
                />
              ) : (
                <>
                  <Typography variant="body1">Jenis</Typography>
                  <Typography variant="body2">
                    Jenis tidak ditemukan, silakan tambah terlebih dahulu pada menu tambah
                    jenis/framework
                  </Typography>
                </>
              )}

              <Typography variant="body1">Framework</Typography>
              <FormGroup>
                {!_.isEmpty(complementsCombo?.libs) ? (
                  complementsCombo?.libs?.map((item, index) => (
                    <FormControlLabel
                      checked={(form.libs && form?.libs[index]?.checked) || false}
                      onChange={(e) => handleChangeCheckbox(index, e.target.checked)}
                      control={<Checkbox />}
                      label={item.label}
                    />
                  ))
                ) : (
                  <Typography variant="body2">
                    Framework tidak ditemukan, silakan tambah terlebih dahulu pada menu tambah
                    jenis/framework
                  </Typography>
                )}
              </FormGroup>
              <Stack direction="row" spacing={1}>
                <Button variant="outlined" onClick={addVersion}>
                  {mode === 'fillingupdate' ? 'Update Versi' : 'Tambah Versi'}
                </Button>
                <Button
                  variant="outlined"
                  sx={{ borderColor: theme.palette.error.main, color: theme.palette.error.main }}
                  onClick={() => setMode('asking')}
                >
                  Cancel
                </Button>
              </Stack>
            </Stack>
          )}
        </Stack>
        <Stack
          direction="column"
          sx={{ flex: 4 }}
          spacing={2}
          divider={<Divider orientation="horizontal" flexItem />}
        >
          <Stack direction="column" spacing={1}>
            <FormControl>
              <Stack direction="row" spacing={1} alignItems="center">
                <FormLabel>Tambah Jenis/Framework</FormLabel>
                <Tooltip
                  title="Data ini digunakan untuk memudahkan proses pendataan versi Aplikasi"
                  arrow
                >
                  <Icon color={theme.palette.grey[500]} icon={questionMarkCircleFill} />
                </Tooltip>
              </Stack>

              <RadioGroup
                sx={{ padding: 1 }}
                aria-labelledby="Tambah jenis/framework"
                value={complement}
                name="complement"
                onChange={(event) => {
                  setComplement(event.target.value);
                }}
              >
                <FormControlLabel value="jenis" control={<Radio />} label="Jenis" />
                <FormControlLabel value="libs" control={<Radio />} label="Framework" />
              </RadioGroup>

              <TextField
                value={complementName}
                onChange={(e) => setComplementName(e.target.value)}
                label="Nama"
                placeholder="(contoh: jenis web, role admin, role pengguna, etc.)"
              />
            </FormControl>

            <Button onClick={addComplement} variant="outlined">
              Tambah {complement}
            </Button>
          </Stack>
          <>
            <Typography variant="body1">Daftar jenis</Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap">
              {_.isEmpty(complements?.jenis) && (
                <Typography variant="body2">Belum ada jenis</Typography>
              )}
              {!_.isEmpty(complements?.jenis) &&
                complements.jenis.map((item) => (
                  <Box sx={{ padding: 0.5 }} key={item.id}>
                    <Chip
                      label={item?.attributes?.name}
                      variant="outlined"
                      onDelete={() => deleteComplement(item)}
                    />
                  </Box>
                ))}
            </Stack>
          </>
          <>
            <Typography variant="body1">Daftar Framework</Typography>
            <Stack direction="row" spacing={1} flexWrap="wrap">
              {_.isEmpty(complements?.libs) && (
                <Typography variant="body2">Belum ada framework</Typography>
              )}
              {!_.isEmpty(complements?.libs) &&
                complements.libs.map((item) => (
                  <Box sx={{ padding: 0.5 }} key={item.id}>
                    <Chip
                      label={item?.attributes?.name}
                      variant="outlined"
                      onDelete={() => deleteComplement(item)}
                    />
                  </Box>
                ))}
            </Stack>
          </>
          <Button variant="outlined" onClick={() => updateApp(complements, versions)}>
            Simpan
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};

FormBuilder.propTypes = {
  user: PropTypes.object.isRequired,
  app: PropTypes.any.isRequired,
  toggleRefresh: PropTypes.func.isRequired
};

AplikasiCreator.propTypes = {
  user: PropTypes.object.isRequired
};

export default AplikasiCreator;
